import { httpGet, httpPost, httpDelete } from "@/request/http";
import func from "@/funcs";

let path = "/promotions";

export default {
  get(id) {
    return httpGet(`${path}/${id}`);
  },
  gets(id, type, isSame) {
    return httpGet(`modules/${id}/type/${type}/promotions/${isSame}`);
  },
  getPage(id, page) {
    return httpGet(`modules/${id}/promotions`, page);
  },
  getModules(item) {
    return httpPost(`modules${path}/query`, item);
  },
  save(item) {
    return httpPost(path, item);
  },
  remove(id) {
    return httpDelete(`${path}/${id}`);
  },
  copy(id, moduleId) {
    return httpPost(`${path}/${id}/copy/modules/${moduleId}`);
  },
  getFoods(id, dTO) {
    return httpGet(`modules/${id}${path}/foods`, dTO);
  },
  getExcel(id) {
    func.getExcel.get(`${path}/${id}/excel`, "促銷模組");
  },
  postExcel(id, formData) {
    return func.postExcel(`${path}/${id}/excel`, formData);
  },
  getGroup(id) {
    return httpGet(`${path}/${id}/group`);
  },
  postGroup(item) {
    return httpPost(`${path}/group`, item);
  },
  getPromotionFoods(id, dTO) {
    return httpGet(`${path}/${id}/foods/pages`, dTO);
  },
  changePosition(item) {
    return httpPost(`modules${path}/priority/position`, item);
  },
};
